import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-animation"
}
const _hoisted_2 = {
  key: 0,
  class: "top-scoring-list-details"
}

import isNil from 'lodash/isNil'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import TopScoringList from '@/components/widgets/public/TopScoringList.vue'
import { useTopScoringListsStore } from '@/store/public/top-scoring-lists'
import { getErrorMessage } from '@/utils/error-handling'
import { formatDate, formatFloat, formatGender } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'TopScoringListView',
  setup(__props) {

const topScoringLists = useTopScoringListsStore()

const errorMessage = ref<string | null>()
const isLoading = ref<boolean>(false)

onMounted(async (): Promise<void> => {
  isLoading.value = true

  const listId = useRoute().params.id

  try {
    await topScoringLists.fetchById(String(listId))
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching top scoring list ID ${listId}: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(BusyIndicator)
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createBlock(NotificationBanner, {
            key: 1,
            message: errorMessage.value,
            "is-danger": ""
          }, null, 8, ["message"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("h1", null, _toDisplayString(_unref(topScoringLists).selected?.name), 1),
            (_unref(topScoringLists).selected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('top-scoring-lists.age-group')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(topScoringLists).selected?.ageGroupName ??
            _ctx.$t('top-scoring-lists.all-age-groups')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('top-scoring-lists.gender')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(!_unref(isNil)(_unref(topScoringLists).selected?.gender)
              ? _unref(formatGender)(_unref(topScoringLists).selected?.gender, true)
              : _ctx.$t('top-scoring-lists.all-genders')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('top-scoring-lists.min-game-count')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(formatFloat)(_unref(topScoringLists).selected?.minimumGameCount, 0)), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('top-scoring-lists.last-updated')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(formatDate)(_unref(topScoringLists).selected?.lastUpdatedAt, true)), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(TopScoringList, {
              list: _unref(topScoringLists).selected
            }, null, 8, ["list"])
          ], 64))
  ]))
}
}

})